export const modules = [
  {
    path: "/dashboard",
    icon: "dashboard",
    title: "首页",
    meta: { title: "首页", icon: "dashboard", noCache: true },
    group: true,
    collapse: true,
    active: true,
    // children: [
    //   {
    //     path: "/dashboard",
    //     title: "首页",
    //     component: () => import("@/views/dashboard/index"),
    //     name: "dashboard",
    //     meta: { title: "首页", prefix: "/dashboard" },
    //   },
    // ],
  },
  // 课程
  //     视频课
  //     组合课
  {
    path: "/course",
    title: "课程管理",
    icon: "course",
    meta: { title: "课程管理", icon: "course" },
    collapse: true,
    children: [
      {
        path: "/course/column",
        title: "专栏管理",
        component: () => import("@/views/course/video"),
        name: "video",
        meta: { title: "专栏管理" },
      },
      // {
      //   path: "/course/private",
      //   title: "私教管理",
      //   component: () => import("@/views/course/video"),
      //   name: "video",
      //   meta: { title: "私教管理" },
      // },
      // {
      //   path: "/course/service",
      //   title: "服务管理",
      //   component: () => import("@/views/course/video"),
      //   name: "video",
      //   meta: { title: "服务管理" },
      // },
      // {
      //   path: "/course/activityList",
      //   title: "单课管理",
      // },
      // {
      //   path: "/teach/book",
      //   title: "资料",
      //   component: () => import("@/views/teaching/book"),
      //   name: "book",
      //   meta: { title: "教学资料", noCache: true },
      // },
      // {
      //   path: "/teach/courseware",
      //   title: "课件",
      //   component: () => import("@/views/teaching/courseware"),
      //   name: "courseware",
      //   meta: { title: "课件", noCache: true },
      // },
    ],
  },
  {
    path: "/content",
    title: "内容管理",
    icon: "content",
    meta: { title: "星球管理", icon: "content", noCache: true },
    component: () => import("@/views/planet/list"),
    collapse: true,
    children: [
      {
        path: "/content/video",
        title: "视频管理",
      },
      {
        path: "/content/audio",
        title: "音频管理",
      },
      {
        path: "/content/rich",
        title: "图文管理",
      },
    ],
  },
  {
    path: "/live",
    title: "直播管理",
    icon: "9",
    meta: { title: "星球管理", icon: "9", noCache: true },
    component: () => import("@/views/planet/list"),
    collapse: true,
    children: [
      {
        path: "/live/create",
        title: "新建直播",
      },
      // {
      //   path: "/live/liveCreate",
      //   component: () => import("@/views/course/liveCreate"),
      //   name: "liveCreate",
      //   title: "新建直播2",
      // },
      {
        path: "/live/list",
        title: "直播管理",
      },
      {
        path: "/live/soft",
        title: "软件下载",
      },
    ],
  },
  {
    path: "/source",
    title: "素材管理",
    icon: "source",
    meta: { title: "素材管理", icon: "source", noCache: true },
    component: () => import("@/views/sources/index"),
    children: [],
  },
  {
    path: "/platform",
    title: "全域获客",
    icon: "allchannel",
    meta: { title: "全域获客", icon: "allchannel", noCache: true },
    // component: () => import("@/views/planet/list"),
    collapse: true,
    children: [
      {
        path: "/platform/dy",
        title: "抖音",
        name: "book",
        meta: { title: "抖音", noCache: true },
      },
      {
        path: "/platform/ks",
        title: "快手",
        name: "book",
        meta: { title: "快手", noCache: true },
      },
      {
        path: "/platform/sph",
        title: "视频号",
        name: "book",
        meta: { title: "视频号", noCache: true },
      },
      {
        path: "/platform/xhs",
        title: "小红书",
        name: "book",
        meta: { title: "小红书", noCache: true },
      },
      {
        path: "/platform/code",
        title: "店铺兑换码",
        component: () => import("@/views/marketing/code"),
        name: "marketingCode",
        meta: { title: "店铺兑换码" },
      },
      {
        path: "/platform/card",
        title: "课程发货",
        component: () => import("@/views/platform/card"),
        name: "platformCard",
        meta: { title: "课程发货" },
      },
      // {
      //   path: "/planet/list",
      //   title: "星球会员",
      //   name: "book",
      //   meta: { title: "星球列表", noCache: true },
      // },
    ],
  },
  // 教学管理
  //     教学资料
  // {
  //   path: "/teach",
  //   title: "教学管理",
  //   icon: "teaching",
  //   meta: { title: "教学管理", icon: "teaching", noCache: true },
  //   collapse: true,
  //   children: [
  //     // {
  //     //   path: "/teach/teacher",
  //     //   title: "讲师管理",
  //     //   component: () => import("@/views/teaching/teacher"),
  //     //   name: "teacher",
  //     //   meta: { title: "讲师管理", noCache: true },
  //     // },
  //     {
  //       path: "/teach/book",
  //       title: "资料",
  //       component: () => import("@/views/teaching/book"),
  //       name: "book",
  //       meta: { title: "教学资料", noCache: true },
  //     },
  //     {
  //       path: "/teach/courseware",
  //       title: "课件",
  //       component: () => import("@/views/teaching/courseware"),
  //       name: "courseware",
  //       meta: { title: "课件", noCache: true },
  //     },
  //   ],
  // },
  // 营销工具
  //     优惠券
  //     限时抢购
  {
    path: "/interaction",
    title: "互动管理",
    icon: "interaction",
    meta: { title: "互动管理", icon: "interaction", noCache: true },
    component: () => import("@/views/planet/list"),
    collapse: true,
    children: [
      {
        path: "/interaction/punch",
        title: "打卡",
        component: () => import("@/views/marketing/coupon"),
        name: "coupon",
        meta: { title: "打卡" },
      },
      // {
      //   path: "/interaction/exam",
      //   title: "考试",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "考试" },
      // },
      // {
      //   path: "/interaction/practice",
      //   title: "练习",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "练习" },
      // },
      // {
      //   path: "/interaction/homework",
      //   title: "作业本",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "作业本" },
      // },
      // {
      //   path: "/interaction/question",
      //   title: "题库",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "题库" },
      // },
      // {
      //   path: "/interaction/cert",
      //   title: "证书",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "证书" },
      // },
      // {
      //   path: "/interaction/form",
      //   title: "表单",
      //   component: () => import("@/views/interaction/form"),
      //   name: "coupon",
      //   meta: { title: "表单" },
      // },
      // {
      //   path: "/interaction/activity",
      //   title: "活动管理",
      //   component: () => import("@/views/interaction/activity"),
      //   name: "coupon",
      //   meta: { title: "活动管理" },
      // },
      // {
      //   path: "/interaction/detection",
      //   title: "随堂检测",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "随堂检测" },
      // },
      // {
      //   path: "/interaction/test",
      //   title: "测试互动",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "测试互动" },
      // },
      // {
      //   path: "/interaction/qapayment",
      //   title: "付费问答",
      //   component: () => import("@/views/marketing/coupon"),
      //   name: "coupon",
      //   meta: { title: "付费问答" },
      // },
      {
        path: "/interaction/comment",
        title: "评论管理",
        component: () => import("@/views/marketing/coupon"),
        name: "coupon",
        meta: { title: "评论管理" },
      },
      {
        path: "/interaction/documents",
        title: "资料管理",
        component: () => import("@/views/interaction/documents"),
        name: "coupon",
        meta: { title: "资料管理" },
      },
      {
        path: "/interaction/pages",
        title: "店铺装修",
        component: () => import("@/views/interaction/pages"),
        name: "coupon",
        meta: { title: "店铺装修" },
      },
    ],
  },
  {
    path: "/marketing",
    title: "营销中心",
    icon: "marketing",
    meta: { title: "营销中心", icon: "marketing" },
    group: true,
    collapse: true,
    children: [
      // {
      //   path: "/marketing/shopwin",
      //   title: "直播橱窗",
      //   component: () => import("@/views/marketing/shopwin"),
      //   name: "shopwin",
      //   meta: { title: "直播橱窗" },
      // },
      {
        path: "/marketing/coupon",
        title: "优惠券",
        component: () => import("@/views/marketing/coupon"),
        name: "coupon",
        meta: { title: "优惠券" },
      },
      {
        path: "/marketing/limited",
        title: "限时抢购",
        component: () => import("@/views/marketing/limited"),
        name: "limited",
        meta: { title: "限时抢购" },
      },
      {
        path: "/marketing/group",
        title: "拼团",
        component: () => import("@/views/marketing/group"),
        name: "limited",
        meta: { title: "拼团" },
      },
      // {
      //   path: "/marketing/course",
      //   title: "买课送课",
      //   component: () => import("@/views/marketing/course"),
      //   name: "marketingCourse",
      //   meta: { title: "买课送课" },
      // },
      // {
      //   path: "/marketing/packet",
      //   title: "套餐",
      //   component: () => import("@/views/marketing/packet"),
      //   name: "packet",
      //   meta: { title: "套餐" },
      // },
      // {
      //   path: "/marketing/page",
      //   title: "店铺装修",
      //   component: () => import("@/views/marketing/page"),
      //   name: "page",
      //   meta: { title: "店铺装修" },
      // },
      // {
      //   path: "/marketing/code",
      //   title: "店铺兑换码",
      //   component: () => import("@/views/marketing/code"),
      //   name: "marketingCode",
      //   meta: { title: "店铺兑换码" },
      // },
    ],
  },
  // 订单管理
  {
    path: "/order",
    title: "订单管理",
    icon: "order",
    meta: { title: "订单管理", icon: "order" },
    collapse: true,
    children: [
      {
        path: "/order/center",
        title: "订单中心",
        component: () => import("@/views/order/center"),
        name: "orderCenter",
        meta: { title: "订单中心" },
      },
      {
        path: "/order/manage",
        title: "抖店订单",
        component: () => import("@/views/order/manage"),
        name: "orderManage",
        meta: { title: "抖店订单" },
      },
    ],
  },
  // 售后管理
  {
    path: "/aftersale",
    title: "售后管理",
    icon: "aftersale",
    meta: { title: "售后管理", icon: "aftersale", noCache: true },
    collapse: true,
    children: [
      {
        path: "/aftersale/index",
        title: "退款管理",
        component: () => import("@/views/aftersale/index"),
        name: "aftersale",
        meta: { title: "退款管理" },
      },
      {
        path: "/aftersale/appeal",
        title: "投诉管理",
        component: () => import("@/views/aftersale/appeal"),
        name: "appeal",
        meta: { title: "投诉管理" },
      },
    ],
  },
  // 用户管理
  {
    path: "/user",
    title: "用户管理",
    icon: "user",
    meta: { title: "用户管理", icon: "user", noCache: true },
    collapse: true,
    children: [
      // {
      //   path: "/user/dashboard",
      //   title: "用户概况",
      //   component: () => import("@/views/user/dashboard"),
      //   name: "userDashboard",
      //   meta: { title: "用户概况", noCache: true },
      // },
      {
        path: "/user/index",
        title: "用户列表",
        component: () => import("@/views/user/index"),
        name: "userList",
        meta: { title: "用户列表", noCache: true },
      },
      {
        path: "/user/tags",
        title: "标签管理",
        component: () => import("@/views/user/tags"),
        name: "userList",
        meta: { title: "标签管理", noCache: true },
      },
      // ,
      // {
      //   path: "/user/groups",
      //   title: "群聊管理",
      //   component: () => import("@/views/user/groups"),
      //   name: "userGroups",
      //   meta: { title: "群聊管理", noCache: true },
      // },
    ],
  },

  // 客户与员工管理
  {
    path: "/manage",
    title: "SCRM",
    icon: "scrm",
    meta: { title: "SCRM", icon: "scrm", noCache: true },
    collapse: true,
    children: [
      {
        path: "/manage/dashboard",
        title: "数据概览",
        component: () => import("@/views/manage/dashboard.vue"),
        name: "manageDashboard",
        meta: { title: "数据概览", noCache: true },
      },
      {
        path: "/manage/customer",
        title: "客户管理",
        component: () => import("@/views/manage/customer.vue"),
        name: "manageCustomer",
        meta: { title: "客户管理", noCache: true },
      },
      {
        path: "/manage/user",
        title: "员工管理",
        component: () => import("@/views/manage/user.vue"),
        name: "manageUser",
        meta: { title: "员工管理", noCache: true },
      },
      {
        path: "/manage/tags",
        title: "客户标签",
        component: () => import("@/views/manage/customerTag.vue"),
        name: "manageCustomerTag",
        meta: { title: "客户标签", noCache: true },
      },
      {
        path: "/manage/corp",
        title: "企业管理",
        component: () => import("@/views/manage/customerCorp.vue"),
        name: "manageCustomerCorp",
        meta: { title: "企业管理", noCache: true },
      },
      {
        path: "/manage/addcorp",
        title: "新增企微",
        component: () => import("@/views/manage/customerAddcorp.vue"),
        name: "manageCustomerAddcorp",
        meta: { title: "新增企微", noCache: true },
      },
    ],
  },

  // 获客配置
  {
    path: "/acquisition",
    title: "获客配置",
    icon: "hoke",
    meta: { title: "获客配置", icon: "hoke", noCache: true },
    collapse: true,
    children: [
      {
        path: "/acquisition/sms",
        title: "短信配置",
        component: () => import("@/views/acquisition/sms.vue"),
        name: "acquisitionSms",
        meta: { title: "短信配置", noCache: true },
      },
      {
        path: "/acquisition/douyin",
        title: "抖音获客",
        component: () => import("@/views/acquisition/douyin.vue"),
        name: "acquisitionDouyin",
        meta: { title: "抖音获客", noCache: true },
      },
      {
        path: "/acquisition/wechat-shop",
        title: "视频号获客",
        component: () => import("@/views/acquisition/wechat-shop.vue"),
        name: "acquisitionWechatShop",
        meta: { title: "视频号获客", noCache: true },
      },
      {
        path: "/acquisition/goods",
        title: "获客商品",
        component: () => import("@/views/acquisition/douyin-product.vue"),
        name: "acquisitionGoods",
        meta: { title: "获客商品", noCache: true },
      },
      {
        path: "/acquisition/claw-skills",
        title: "Claw Skills",
        component: () => import("@/views/acquisition/claw-skills.vue"),
        name: "acquisitionClawSkills",
        meta: { title: "Claw Skills", noCache: true },
      },
    ],
  },

  // 数据中心
  //     课程分析
  //     学员分析
  //     直播分析
  {
    path: "/database",
    title: "数据中心",
    icon: "database",
    meta: { title: "数据中心", icon: "database", noCache: true },
    collapse: true,
    children: [
      {
        path: "/database/analysis",
        title: "销售数据",
        component: () => import("@/views/database/analysis"),
        name: "databaseCourse",
        meta: { title: "销售数据", noCache: true },
      },
      {
        path: "/database/course",
        title: "课程分析",
        component: () => import("@/views/database/course"),
        name: "databaseCourse",
        meta: { title: "课程分析", noCache: true },
      },
      {
        path: "/database/student",
        title: "学员分析",
        component: () => import("@/views/database/student"),
        name: "databaseStudent",
        meta: { title: "学员分析", noCache: true },
      },
      {
        path: "/database/living",
        title: "直播分析",
        component: () => import("@/views/database/living"),
        name: "databaseLiving",
        meta: { title: "直播分析", noCache: true },
      },
      // {
      //   path: "/database/costomer",
      //   title: "潜客分析",
      //   component: () => import("@/views/database/costomer"),
      //   name: "databaseCostomer",
      //   meta: { title: "潜客分析", noCache: true },
      // },
    ],
  },
  // 资金收益
  {
    path: "/accounting",
    title: "资金管理",
    icon: "accounting",
    meta: { title: "资金管理", icon: "accounting", noCache: true },
    collapse: true,
    children: [
      // {
      //   path: "/accounting/detail",
      //   title: "资金明细",
      //   component: () => import("@/views/accounting/index"),
      //   name: "accountingDetail",
      //   meta: { title: "资金明细" },
      // },
      {
        path: "/accounting/balance",
        title: "提现管理",
        component: () => import("@/views/accounting/balance"),
        name: "accountingBalance",
        meta: { title: "提现管理" },
      },
      {
        path: "/accounting/wechat-pay",
        title: "微信支付开户",
        component: () => import("@/views/accounting/wechatPay"),
        name: "accountingWechatPay",
        meta: { title: "微信支付开户" },
      },
    ],
  },
  // 新手引导
  {
    path: "/setting",
    title: "新手指南",
    icon: "beginner",
    meta: { title: "新手指南", icon: "beginner" },
    collapse: true,
    children: [
      {
        path: "/guide/index",
        title: "入驻引导",
        component: () => import("@/views/setting/guide"),
        name: "guide",
        meta: { title: "入驻引导" },
      },
      // {
      //   path: "/setting/index",
      //   title: "抖音资质",
      //   component: () => import("@/views/setting/index"),
      //   name: "accountingSetting",
      //   meta: { title: "抖音资质管理" },
      // },
      // {
      //   path: "/setting/ttScope",
      //   title: "抖音账号",
      //   component: () => import("@/views/setting/ttScope"),
      //   name: "ttScope",
      //   meta: { title: "抖音账号管理" },
      // },
    ],
  },
  {
    path: "/setting",
    title: "系统设置",
    icon: "setting",
    meta: { title: "系统设置", icon: "setting" },
    collapse: true,
    children: [
      {
        path: "/setting/self",
        title: "账号信息",
        component: () => import("@/views/setting/self"),
        name: "accountingSetting",
        meta: { title: "账号信息" },
      },
      {
        path: "/setting/accounting",
        title: "员工管理",
        component: () => import("@/views/setting/manage"),
        name: "accountingManage",
        meta: { title: "员工管理" },
      },
      {
        path: "/setting/department",
        title: "部门管理",
        component: () => import("@/views/setting/department"),
        name: "accountingDepartment",
        meta: { title: "部门管理" },
      },
      // {
      //   path: "/setting/record",
      //   title: "导出记录",
      //   component: () => import("@/views/setting/record"),
      //   name: "record",
      //   meta: { title: "导出记录" },
      // },
      {
        path: "/setting/role",
        title: "权限管理",
        component: () => import("@/views/setting/role"),
        name: "accountingRole",
        meta: { title: "权限管理" },
      },
      {
        path: "/setting/operationLog",
        title: "操作日志",
        component: () => import("@/views/setting/operationLog"),
        name: "operationLog",
        meta: { title: "操作日志" },
      },
      {
        path: "/setting/serviceSubscription",
        title: "服务订购",
        component: () => import("@/views/setting/serviceSubscription"),
        name: "serviceSubscription",
        meta: { title: "服务订购" },
      },
      {
        path: "/accounting/wechat-pay/apply",
        title: "微信支付开户",
        component: () => import("@/views/accounting/wechatPayApply"),
        name: "accountingWechatPayApply",
        meta: { title: "微信支付开户" },
      },
      // {
      //   path: "/setting/api",
      //   title: "开发设置",
      //   component: () => import("@/views/setting/api"),
      //   name: "accountingAPI",
      //   meta: { title: "开发设置" },
      // },
    ],
  },
];
